<template lang="pug">
  .attempt
    Frame
      .attempt__title You scored
        span.attempt__points  {{ points }}&nbsp;points.
      p.attempt__text You have
        b  {{ attemptValue }}
        |  left to&nbsp;show the&nbsp;best&nbsp;result.
      .attempt__icon
      Buttons(type="go", @reset="() => $emit('reset')")
</template>

<script>
import Frame from '@/components/UI/Frame';
import Buttons from '@/components/UI/Buttons';

import { mapGetters } from 'vuex';

export default {
  name: 'Attempt',
  props: ['points'],
  components: { Frame, Buttons },
  computed: {
    ...mapGetters(['tries']),
    attemptValue() {
      return this.tries === 1 ? 'last attempt' : `${this.tries} attempts`;
    },
  },
};
</script>

<style scoped lang="scss">
  .attempt {
    z-index: z('header');
    position: relative;
    &__title {
      @include typo-h1;
      color: $clr-main;
    }
    &__text {
      @include typo-text;
      color: $clr-blue;
      margin: 20px 0 0;
      @media (max-width: $max-width-xs) {
        @include typo-p(normal);
      }
    }
    &__points {
      color: $clr-darkMain;
      white-space: nowrap;
    }
    &__icon {
      @include vertical-align;
      justify-content: center;
      margin: 68px 0 0;
      @media (max-width: $max-width-xs) {
        margin: 74px 0 0;
      }
      &:before {
        @include pseudo($pos: relative);
        @include retina-sprite($icon-bg-group);
        @media (max-width: $max-width-xs) {
          @include retina-sprite($icon-bg-xs-group);
        }
      }
      &:after {
        @include pseudo;
        @include retina-sprite($icon-flag-group);
        @media (max-width: $max-width-xs) {
          @include retina-sprite($icon-flag-xs-group);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/Attempt.vue